import React, { useState, useEffect } from "react";
import {
  Grid, Container, Header, Image, Icon, Button, Loader, Form
} from 'semantic-ui-react';

const ExitIntentPopup = ({quotationID}) => {
  const [showPopup, setShowPopup] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const [step, setStep] = React.useState("default");

  useEffect(() => {
    // Detectar dispositivos móveis
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768); // Altere o limite se necessário
    };
    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);

    // Eventos para desktop
    const handleMouseLeave = (e) => {
      if (e.clientY <= 0) {
        setShowPopup(true);
      }
    };

    // Eventos para mobile (simula intenção de saída por inatividade)
    const handleInactivity = () => {
      let timer;
      const resetTimer = () => {
        clearTimeout(timer);
        timer = setTimeout(() => setShowPopup(true), 1000*60*10); // 5 segundos de inatividade
      };
      window.addEventListener("touchstart", resetTimer);
      window.addEventListener("scroll", resetTimer);

      resetTimer();
      return () => {
        clearTimeout(timer);
        window.removeEventListener("touchstart", resetTimer);
        window.removeEventListener("scroll", resetTimer);
      };
    };

    if (!isMobile) {
      document.addEventListener("mouseleave", handleMouseLeave);
    } else {
      const cleanup = handleInactivity();
      return cleanup;
    }

    return () => {
      document.removeEventListener("mouseleave", handleMouseLeave);
      window.removeEventListener("resize", checkIfMobile);
    };
  }, [isMobile]);

  const handleClosePopup = () => setShowPopup(false);

  const redirectToWhatsapp = (e) => {
    e.preventDefault();
    const message = e.target.innerText;
    window.location.href = "https://api.whatsapp.com/send?phone=5541987811674&text="+message+" - cotação: "+quotationID;
  }

  return (
    <>
      {showPopup && (
        <div className="popup exit-popup">
         {step === "default" && (
          <div className="first-stage">
            <button id="close-popup" onClick={handleClosePopup}>X</button>
            <Header as="h1" className="compact title-continue">
                Não se vá! 🥺
            </Header>
            <p className='store-color'>Notamos que você está querendo deixar a página sem continuar a venda.</p>
            <p className='store-color'>Nos ajude a entender o que está acontecendo!</p>
            <button id="next" onClick={handleClosePopup}>Continuar a venda</button>
            <button id="leave-selling" onClick={() => setStep('leave')}>Desistir da venda</button>
          </div>
          )}
          {step === "leave" && (
            <div className="reason"> 
              <Header as="h1" className="compact title-continue">
                Poderia nos informar por qual motivo desistiu da venda?
              </Header>
              <Container textAlign="center" >
                <Grid className="buttons-pair" columns={1} stackable reversed="computer tablet">
                  <Grid.Column>
                    <button onClick={redirectToWhatsapp}>Não gostei dos valores!</button>
                  </Grid.Column>
                  <Grid.Column>
                  <button onClick={redirectToWhatsapp}>Não entendi a cotação!</button>
                  </Grid.Column>
                  <Grid.Column>
                  <button onClick={redirectToWhatsapp}>Outro motivo</button>
                  </Grid.Column>
                </Grid>
              </Container>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ExitIntentPopup;
